<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="300 50 600 850">
    <g>
      <path
        class="st2"
        d="M391.21,313.61c0.05-104.63,85.07-189.57,189.73-189.55c103.93,0.02,189.65,84.19,189.51,189.99
		c-0.14,104.85-84.97,189.54-189.83,189.41C475.52,503.34,391.26,418.15,391.21,313.61z M754.28,313.89
		c-0.19-97.11-78.7-173.37-172.97-173.59c-95.48-0.22-173.68,77.09-173.83,173.22c-0.15,95.37,76.83,173.38,172.79,173.72
		C675.8,487.57,753.99,410.53,754.28,313.89z"
      />
      <path
        class="st2"
        d="M495.66,704.45c-0.79,0-1.57,0-2.36,0c-11.06,0-22.12-0.04-33.17,0.03c-1.81,0.01-3.13-0.5-4.44-1.78
		c-14.4-14-28.88-27.91-43.26-41.93c-1.65-1.61-3.3-2.26-5.59-2.24c-10.35,0.1-20.7,0.05-31.05,0.05c-0.94,0-1.89,0-3.09,0
		c0,15.36,0,30.37,0,45.29c-2.19,0.71-25.27,0.8-28,0.16c0-39.02,0-78.08,0-117.29c9.24,0,18.31,0,27.79,0
		c0.27,3.63,0.07,7.3,0.09,10.97c0.02,3.8-0.01,7.61-0.02,11.41c-0.01,3.72-0.01,7.43-0.01,11.15c0,3.71,0,7.42,0,11.32
		c0.78,0.13,1.44,0.33,2.09,0.33c11.94,0.05,23.88,0.06,35.83,0.14c1.38,0.01,2.3-0.53,3.24-1.44
		c14.36-14.04,28.77-28.03,43.09-42.11c1.45-1.43,2.88-1.98,4.88-1.97c10.79,0.08,21.58,0.04,32.38,0.04c0.86,0,1.72,0,2.58,0
		c0.09,0.16,0.18,0.32,0.27,0.49c-20.4,19.65-40.81,39.29-61.5,59.21c20.21,19.31,40.41,38.39,60.52,57.56
		C495.84,704.05,495.75,704.25,495.66,704.45z"
      />
      <path
        class="st2"
        d="M187.5,679.46c1.2,0,2.35,0,3.49,0c28.93,0,57.86,0,86.79,0c0.8,0,1.59,0.02,2.39-0.01
		c3.7-0.1,5.99-2.23,6.1-5.93c0.12-3.98,0.06-7.96,0.04-11.94c0-1.56-0.08-3.13-0.13-4.93c-1.43,0-2.57,0-3.7,0
		c-26.9,0-53.79-0.02-80.69,0.02c-4.3,0.01-8.49-0.45-12.42-2.26c-9.14-4.21-14-11.4-14.26-21.46c-0.19-7.25-0.23-14.52,0.01-21.77
		c0.47-14.42,12.21-25.03,26.59-24.54c0.17,0.01,0.33,0.1,0.89,0.28c0,0.81,0,1.75,0,2.68c0,11.33,0,22.65,0,33.98
		c0,0.8-0.03,1.59,0.02,2.39c0.18,3.19,2.38,5.42,5.57,5.66c0.79,0.06,1.59,0.02,2.39,0.02c25.83,0,51.67-0.02,77.5,0.04
		c2.63,0.01,5.33,0.22,7.88,0.84c10.85,2.64,17.71,11.25,18,22.71c0.2,8.05,0.19,16.11,0.01,24.15
		c-0.29,12.53-8.61,22.29-20.82,24.66c-1.64,0.32-3.34,0.38-5.01,0.38c-37.78,0.02-75.56,0.02-113.33,0.01
		c-0.77,0-1.53-0.08-2.75-0.15C177.31,695.84,182.38,687.69,187.5,679.46z"
      />
      <path
        class="st2"
        d="M311.06,586.88c-5.11,8.12-10.05,15.96-15.03,23.87c-22.05,0-44.05,0-66.27,0c-4.91-7.8-9.89-15.71-14.9-23.67
		C216.92,586.49,306.77,586.3,311.06,586.88z"
      />
      <path
        class="st2"
        d="M833.07,628.72c-0.08-11.37-3.86-21.32-11.91-29.47c-8.39-8.49-18.74-12.4-30.55-12.65
		c-4.42-0.09-8.84-0.02-13.27-0.02c-28.66,0-57.32,0-85.98,0c-1.11,0-2.22,0.05-3.41,0.07c0,39.35,0,78.34,0,117.63
		c1.07,0.06,1.85,0.14,2.63,0.14c33.52,0,67.05,0.02,100.57-0.04c2.81-0.01,5.67-0.28,8.42-0.86c20.05-4.23,33.22-20.38,33.48-41.11
		C833.21,651.19,833.15,639.96,833.07,628.72z M804.89,664.6c-0.09,7.83-5.95,13.44-13.81,13.45c-24.24,0.05-48.47,0.02-72.71,0.01
		c-0.69,0-1.39-0.1-2.37-0.17c0-21.67,0-43.06,0-64.67c0.69-0.09,1.36-0.24,2.02-0.24c24.41-0.01,48.83-0.05,73.24,0.02
		c7.65,0.02,13.52,5.71,13.62,13.38C805.05,639.12,805.05,651.86,804.89,664.6z"
      />
      <path
        class="st2"
        d="M656.04,627.8c-0.03-7.99-2.19-15.41-6.62-22.04c-8.66-12.93-21.08-19.03-36.44-19.14
		c-21.41-0.14-42.82-0.06-64.23-0.01c-2.64,0.01-5.32,0.19-7.92,0.61c-20.67,3.37-35.09,20.16-35.33,41.22
		c-0.13,11.41-0.1,22.83,0,34.24c0.08,9.08,2.58,17.48,8.1,24.78c8.2,10.85,19.25,16.52,32.77,16.89
		c11.4,0.31,22.82,0.06,34.23,0.06c0,0.01,0,0.01,0,0.02c10.79,0,21.59,0.04,32.38-0.03c2.73-0.02,5.49-0.2,8.18-0.61
		c19.85-2.98,34.8-20.33,34.87-40.44C656.09,651.51,656.08,639.66,656.04,627.8z M627.96,664.71c-0.05,7.41-5.92,13.18-13.4,13.34
		c-5.13,0.11-10.26,0.03-15.38,0.03c-6.1,0-12.2,0-18.3,0c-11.14,0-22.28,0.04-33.42-0.02c-6.33-0.03-11.35-3.69-13.15-9.59
		c-0.48-1.58-0.7-3.3-0.71-4.96c-0.06-11.94-0.04-23.88-0.02-35.81c0-2.31,0.28-4.59,1.32-6.7c2.44-4.95,6.41-7.61,11.91-7.99
		c0.44-0.03,0.88-0.02,1.33-0.02c21.75,0,43.5,0.01,65.25-0.01c2.24,0,4.42,0.23,6.45,1.2c5.07,2.43,8.03,6.47,8.1,12.08
		C628.09,639.06,628.06,651.89,627.96,664.71z"
      />
      <path
        class="st2"
        d="M1014.41,701.91c-21.2-37.77-42.41-75.54-63.56-113.34c-0.87-1.55-1.82-2.04-3.54-2.03
		c-11.32,0.07-22.65,0.09-33.97-0.01c-1.96-0.02-2.97,0.68-3.9,2.35c-21.11,37.72-42.28,75.41-63.43,113.11
		c-0.37,0.67-0.68,1.38-1.13,2.3c1.04,0.06,1.81,0.13,2.58,0.14c8.58,0.01,17.16-0.07,25.74,0.06c2.1,0.03,3.13-0.71,4.1-2.47
		c7.24-13.07,14.58-26.08,21.9-39.1c0.49-0.88,1.03-1.72,1.69-2.81c0.74,1.12,1.23,1.85,1.7,2.59c3.97,6.28,7.96,12.54,11.86,18.86
		c0.75,1.22,1.58,1.79,2.98,1.62c0.61-0.07,1.24-0.01,1.86-0.01c16.36,0,32.73,0.08,49.09-0.08c2.73-0.03,4.09,0.87,5.28,3.19
		c2.5,4.87,5.31,9.59,7.99,14.37c0.69,1.23,1.41,2.44,2.08,3.6c10.6,0,21.06,0,31.82,0
		C1015.09,703.29,1014.79,702.58,1014.41,701.91z M901.59,658.62c9.44-16.81,18.71-33.32,28.23-50.29
		c9.53,16.97,18.81,33.49,28.13,50.08C955.81,658.98,906.02,659.16,901.59,658.62z"
      />
      <path
        class="st2"
        d="M587.25,238.94c-0.46-1-0.9-2.03-1.4-3.03c-6.48-12.88-14.76-24.54-24.07-35.49
		c-8.56-10.06-17.83-19.42-27.88-27.99c-0.46-0.39-1.06-0.63-1.6-0.94c0.12-0.27,0.24-0.53,0.37-0.8c4.41-1.19,8.79-2.52,13.23-3.56
		c14.3-3.36,28.82-4.33,43.47-3.78c3.57,0.13,6.48,1.16,9.3,3.58c19.12,16.45,34.46,35.73,44.9,58.78
		c6.57,14.51,10.85,29.68,13.07,45.45c1.51,10.71,2.22,21.47,1.89,32.28c-0.81,27.11-6.08,53.33-15.84,78.64
		c-0.31,0.82-0.63,1.63-1.02,2.65c0.7,0.14,1.26,0.35,1.83,0.35c3.8,0.03,7.61-0.05,11.41,0.05c1.52,0.04,2.21-0.61,2.68-1.95
		c1.11-3.15,2.33-6.27,3.58-9.6c18.12,2.42,33.45,10.02,46.39,23.05c-12.87,13.01-28.19,20.61-46.35,23.09
		c-1.46-3.78-2.87-7.46-4.37-11.34c-1.06,0-2.02,0-2.98,0c-45.39,0-90.78,0.01-136.17-0.02c-1.83,0-3.44,0.37-5.06,1.23
		c-5.32,2.81-10.71,5.47-16.03,8.27c-2.25,1.18-4.57,1.78-7.11,1.75c-5.4-0.06-10.79-0.04-16.19,0c-1.22,0.01-2.19-0.27-3.05-1.21
		c-11.87-12.95-21.49-27.39-28.65-43.44c-0.14-0.31-0.2-0.65-0.37-1.21c0.78-0.08,1.44-0.2,2.09-0.2
		c14.16-0.01,28.31,0.01,42.47-0.02c2.08,0,4.01,0.46,5.9,1.3c7.03,3.11,14.09,6.16,21.12,9.28c1.57,0.7,3.15,1.07,4.87,1.02
		c2.56-0.07,5.13-0.01,7.7-0.03c0.86-0.01,1.72-0.09,2.86-0.15c-0.23-2.17-0.4-4.09-0.65-6c-1.27-9.7-3.65-19.08-7.78-27.99
		c-6.6-14.23-16.92-25.14-29.96-33.61c-12.05-7.82-25.22-13.13-38.97-17.04c-6.62-1.89-13.34-3.45-20.33-5.24
		c0-0.63-0.11-1.49,0.02-2.32c2.88-18.71,8.73-36.4,18.2-52.84c0.26-0.46,0.59-0.87,1.03-1.54c2.68,0.64,5.42,1.25,8.14,1.96
		c18.44,4.79,36.45,10.78,53.37,19.65c4.84,2.54,9.45,5.54,14.07,8.49c3.07,1.96,2.99,2.08,6.41-0.31c-0.67-0.8-1.29-1.62-1.98-2.38
		c-6.53-7.16-14.04-13.21-21.78-18.97c-13.36-9.94-27.35-18.89-41.87-27.05c-0.76-0.43-1.5-0.88-2.46-1.44
		c1.51-1.77,2.84-3.41,4.26-4.97c11.06-12.1,23.57-22.41,37.89-30.48c1.73-0.97,3.14-1.07,4.95-0.3
		c11.17,4.74,21.18,11.35,30.67,18.8c13.69,10.73,25.99,22.94,37.7,35.76c0.24,0.26,0.47,0.53,0.71,0.79
		C582.68,241.02,583.06,241.08,587.25,238.94z M625.46,348.86c0.03-10.42-8.22-18.79-18.57-18.84
		c-10.55-0.05-18.91,8.22-18.94,18.75c-0.03,10.49,8.43,18.97,18.85,18.9C617.17,367.59,625.43,359.26,625.46,348.86z"
      />
    </g>
  </svg>
</template>
